export default __webpack_public_path__ + "011cd8beeeacdee3aefd493f76dff21a.png";